import { Quote } from './quote/quote';
import { QuoteWithMedia } from './quote/quote-with-media';
import { QuoteCarouselItemProps } from './quote-carousel-item.config';

const QuoteCarouselItem = ({
  cqPath,
  image,
  isInEditor,
  logo,
  person,
  quote,
  titleOfPerson,
  wistia_video: wistiaVideo,
}: QuoteCarouselItemProps) => {
  return !image && !wistiaVideo ? (
    <Quote logo={logo} person={person} quote={quote} titleOfPerson={titleOfPerson} />
  ) : (
    <QuoteWithMedia
      image={image}
      video={{ cqPath, isInEditor, ...wistiaVideo }}
      quote={quote}
      person={person}
      titleOfPerson={titleOfPerson}
      logo={logo}
    />
  );
};

export default QuoteCarouselItem;
